<template>
    <div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
        <!-- Indicators -->
        <div class="carousel-indicators">
            <button v-for="(image, index) in slideImages" :key="index" type="button"
                :data-bs-target="'#carouselExample'" :data-bs-slide-to="index" :class="{ active: index === 0 }"
                aria-current="true" aria-label="'Slide ' + (index + 1)"></button>
        </div>

        <!-- Slides -->
        <div class="carousel-inner">
            <div v-for="(event, index) in slideImages" :key="index" class="carousel-item"
                :class="{ active: index === 0 }" @click="goToDetails(event.id)">
                <img :src="event.imageUrl" class="d-block w-100" :alt="'Slide ' + (index + 1)" />
                <div class="carousel-caption d-md-block">
                    <div class="carousel-caption-text">
                        <h5 class="title">{{ event.title }}</h5>
                        <p class="description">
                            {{ event.city }}<br>
                            <span class="carousel-caption-text-span">{{ formatDate(event.startDate) }}, {{
                                formatTime(event.startTime) }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Controls -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Föregående</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Nästa</span>
        </button>
    </div>
</template>

<script>
import { toRaw } from "vue";
import AxiosInstance from "../api/axios";
import EventResponse from "../aggrigates/events/models/EventResponse.js";
export default {
    data() {
        return {
            slideImages: [],
        };
    },
    async mounted() {
        this.fetchPromotedEvents();
    },
    methods: {
        goToDetails(id) {
            window.location.href = `/eventdetails/${id}`;
        },
        async fetchPromotedEvents() {
            try {
                const eventResponse = new EventResponse();
                const response = await AxiosInstance.get("events/promoted");
                eventResponse.fromResponse(response.data);

                if (eventResponse.items.length === 0) {
                    return;
                }

                this.slideImages = toRaw(eventResponse.items);

            } catch (error) {
                console.error("Error fetching events:", error);
                this.hasError = true;
            }
        },
        formatDate(dateString) {
            const now = new Date(); // Current date and time
            const inputDate = new Date(dateString); // Convert the input string to a Date object

            // Check if the input date is today
            if (
                inputDate.getFullYear() === now.getFullYear() &&
                inputDate.getMonth() === now.getMonth() &&
                inputDate.getDate() === now.getDate()
            ) {
                return 'Idag';
            }

            // Calculate the difference in days
            const differenceInTime = inputDate.getTime() - now.getTime();
            const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24)); // Convert to days

            // If the date is within the next week
            if (differenceInDays > 0 && differenceInDays <= 7) {
                return `Om ${differenceInDays} dagar`;
            }

            // Otherwise, format it as YYYY-MM-DD
            return dateString.split('T')[0];
        },
        formatTime(timeString) {
            return timeString.split(':').slice(0, 2).join(':');
        },
    }
};
</script>

<style scoped>
.carousel-inner {
    width: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
    cursor: pointer;
}

.carousel-item img {
    height: 800px;
    object-fit: inherit;
    cursor: pointer;
}

.carousel-container {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.b-carousel {
    width: 100%;
    height: 150px;
    position: relative;
    /* Positioned to allow z-index */
    z-index: 1000;
    /* Ensure the carousel stays behind other elements */
    overflow: visible;
}

.b-carousel-slide img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.5) !important;
    /* Applying the shadow */
    position: relative;
    /* Positioned to allow z-index */
    z-index: 2000;
    /* Ensure the image is above the carousel but behind the dots */
}

.carousel-caption {
    text-align: left !important;
    bottom: 0rem !important;
    left: 0% !important;
    text-align: left;
    color: white;
    background: rgba(0, 0, 0, 0.5);
    padding: 10px;
    width: 100% !important;
    height: 90px;
}

.carousel-caption-text {
    padding-left: 20px;
}

.carousel-caption-text h5 {
    font-size: 1rem;
}

.carousel-caption-text p {
    font-size: 0.8rem;
}

.carousel-caption-text-span {
    font-size: 0.8rem;
}

/* Responsive behavior for smaller screens */
@media (max-width: 1200px) {
    .carousel-item img {
        height: 450px;
    }

    .carousel-caption-text h5 {
        font-size: 1.5rem;
    }

    .carousel-caption-text p {
        font-size: 1.2rem;
    }
}

@media (max-width: 1199px) {
    
    .carousel-caption {
        height: 70px;
    }

    .carousel-caption-text h5 {
        font-size: 0.8rem;
    }

    .carousel-caption-text p {
        font-size: 0.6rem;
    }

    .carousel-caption-text-span {
        font-size: 0.6rem;
    }
}

@media (max-width: 768px) {
    .carousel-item img {
        height: 300px;
    }

    .carousel-caption-text h5 {
        font-size: 1rem;
    }

    .carousel-caption-text p {
        font-size: 0.8rem;
    }

    .carousel-caption {
        height: 65px;
    }

    .carousel-caption-text h5 {
        font-size: 0.8rem;
    }

    .carousel-caption-text p {
        font-size: 0.6rem;
    }

    .carousel-caption-text-span {
        font-size: 0.6rem;
    }
}

@media (max-width: 480px) {
    .carousel-item img {
        height: 230px;
    }

    .carousel-caption-text h5 {
        font-size: 0.7rem;
    }

    .carousel-caption-text p {
        font-size: 0.7rem;
    }

    .carousel-caption {
        height: 65px;
    }

    .carousel-caption-text h5 {
        font-size: 0.8rem;
    }

    .carousel-caption-text p {
        font-size: 0.6rem;
    }

    .carousel-caption-text-span {
        font-size: 0.6rem;
    }
}
</style>